import React from 'react';


/**
 *
 * Sofology Logo SVG
 *
 */
function SofologyLogo() {
  return (
    <svg
      width="100%"
      height="100%"
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      className="sofology-logo"
      x="32"
    >
      <title>sofology</title>
      <g transform="translate(6 9)" fill="none" fillRule="evenodd">
        <path
          fill="rgb(222, 0, 123)"
          d="M30.55 8.432a.481.481 0 0 1-.482.481h-7.4a.481.481 0 0 1-.482-.48V1.047c0-.265.215-.48.481-.48h7.384a.481.481 0 0 1 .481.48v7.384h.018zM22.186 16.773a.481.481 0 0 1-.481.48h-7.378a.481.481 0 0 1-.481-.48V9.389c0-.266.215-.481.48-.481h7.385c.265 0 .48.215.48.48v7.385h-.005z"
        />
        <path
          fill="rgb(0, 159, 238)"
          d="M8.34 20.949a.481.481 0 0 1-.48.48H.48A.481.481 0 0 1 0 20.95v-7.39c0-.266.215-.481.481-.481h7.384a.481.481 0 0 1 .481.481v7.384l-.005.006zM16.687 29.29a.481.481 0 0 1-.481.48H8.822a.481.481 0 0 1-.481-.48v-7.385c0-.265.215-.48.48-.48h7.408c.265 0 .48.215.48.48v7.384h-.022z"
        />
        <path
          fill="rgb(255, 240, 0)"
          d="M27.554 29.29a.481.481 0 0 1-.482.48h-7.406a.481.481 0 0 1-.482-.48v-7.385c0-.265.216-.48.482-.48h7.383c.266 0 .482.215.482.48v7.384h.023zM35.894 20.949a.481.481 0 0 1-.481.48h-7.384a.481.481 0 0 1-.481-.48v-7.39c0-.266.215-.481.481-.481h7.384c.266 0 .481.215.481.481V20.95z"
        />
      </g>
    </svg>
  );
}

export default SofologyLogo;




// WEBPACK FOOTER //
// ./src/layout/graphics/SofologyLogo.js